


































import { Component, Vue, Prop } from 'vue-property-decorator';

import VueError from '@/components/VueError.vue';
import EnterpriseId from '@/components/EnterpriseId.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';
import ReadingList from "@/components/ReadingList.vue";
import {Device, Group} from "@/types/core";
import tippy from "tippy.js";
import {CoreClient, curCoreClient} from "@/services/CoreClient";
import {curGroupService} from "@/services/GroupService";
import _ from "lodash";

@Component({
  components:{
    VueError,
    EnterpriseId,
    TimestampAgo,
    ReadingList
  }
})
export default class GroupRow extends Vue {

  error:string = '';
  @Prop({ default: {}, type: Object}) bus!: Vue;
  @Prop({ default: '', type: String}) enterpriseId!: string;
  @Prop({ default: '',  type: String}) group!: string;
  @Prop({ default: 0,  type: Number}) index!: number;

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;

  numDevices = 0;
  deviceList:Device[] = [];
  async mounted() {

    let enterprisePrefix = 'neura.';
    if (this.enterpriseId === 'neura') {
      enterprisePrefix = '';
    }
    const reply = await this.coreClient.getDevicesInGroup({
      skip: 0,
      limit: 100000,
      groupIdList: `${enterprisePrefix}${this.enterpriseId}.${this.group}`,
    });

    if ( reply.errorMsg ) {
      this.error = reply.errorMsg;
    }
    if ( reply.deviceList ) {
      this.deviceList = reply.deviceList;
      this.numDevices = reply.deviceList.length;
    }
    tippy('[data-tippy-content]');
  }

  async goToGroup() {
    this.bus.$emit('devices-search', this.enterpriseId, this.group);
  }

  configureDevices() {
    this.$router.push({
      name: 'configure-devices',
      params: {
        groupId: this.commonGroup()[0],
      },
    });
  }

  get canConfigureDevices():boolean {
    return curGroupService.canConfigureDevices(this.deviceList);
  }

  commonGroup():string[] {
    return curGroupService.commonGroup(this.deviceList);
  }
}

